// Premium color palette inspired by Databox's BI-tool aesthetic
// Each color has a base, light (for backgrounds/gradients), and dark variant

export const COLORS = {
  // Primary palette - used for main chart segments
  blue:    { base: '#3B82F6', light: '#DBEAFE', dark: '#1D4ED8', gradient: ['#60A5FA', '#2563EB'] },
  emerald: { base: '#10B981', light: '#D1FAE5', dark: '#047857', gradient: ['#34D399', '#059669'] },
  amber:   { base: '#F59E0B', light: '#FEF3C7', dark: '#B45309', gradient: ['#FBBF24', '#D97706'] },
  violet:  { base: '#8B5CF6', light: '#EDE9FE', dark: '#6D28D9', gradient: ['#A78BFA', '#7C3AED'] },
  rose:    { base: '#F43F5E', light: '#FFE4E6', dark: '#BE123C', gradient: ['#FB7185', '#E11D48'] },
  teal:    { base: '#14B8A6', light: '#CCFBF1', dark: '#0F766E', gradient: ['#2DD4BF', '#0D9488'] },
  indigo:  { base: '#6366F1', light: '#E0E7FF', dark: '#4338CA', gradient: ['#818CF8', '#4F46E5'] },
  orange:  { base: '#F97316', light: '#FFEDD5', dark: '#C2410C', gradient: ['#FB923C', '#EA580C'] },
  cyan:    { base: '#06B6D4', light: '#CFFAFE', dark: '#0E7490', gradient: ['#22D3EE', '#0891B2'] },
  pink:    { base: '#EC4899', light: '#FCE7F3', dark: '#BE185D', gradient: ['#F472B6', '#DB2777'] },
};

// Ordered palette for chart segments
export const CHART_PALETTE = [
  COLORS.blue,
  COLORS.emerald,
  COLORS.amber,
  COLORS.violet,
  COLORS.rose,
  COLORS.teal,
  COLORS.indigo,
  COLORS.orange,
  COLORS.cyan,
  COLORS.pink,
];

// Semantic colors for KPI indicators
export const SEMANTIC = {
  positive: '#10B981',
  negative: '#EF4444',
  neutral: '#6B7280',
  warning: '#F59E0B',
};

// Background/surface colors
export const SURFACE = {
  page: '#F8FAFC',
  card: '#FFFFFF',
  cardHover: '#F1F5F9',
  border: '#E2E8F0',
  borderLight: '#F1F5F9',
  text: '#0F172A',
  textSecondary: '#475569',
  textMuted: '#94A3B8',
  gridLine: '#F1F5F9',
};
